import {
  getCCExpDateValid,
  getCCValid,
  getEmailValid,
  getPhoneValid,
  getZipValid,
} from '../Profile/utils'

export const normalizeDigits = (value: string) => value.replace(/\D/g, '')

export const normalizePhoneDigits = normalizeDigits

export const isValidEmail = (value: string) => getEmailValid(value.trim())

export const isValidPhoneNumber = (value: string) => getPhoneValid(value)

export const isValidZipCode = (value: string) =>
  getZipValid(normalizeDigits(value))

export const isValidCardNumber = (value: string) => {
  const digits = normalizeDigits(value)
  const isAmex = /^3[47]/.test(digits)

  return getCCValid(isAmex, digits)
}

export const isValidExpirationDate = (value: string) =>
  getCCExpDateValid(value)

export const getRequiredTextError = (value: string, label: string) =>
  value.trim() === '' ? `${label} is required.` : ''

export const getRequiredEmailError = (value: string, label = 'Email') => {
  if (value.trim() === '') {
    return `${label} is required.`
  }

  if (!isValidEmail(value)) {
    return 'Enter a valid email address.'
  }

  return ''
}

export const getRequiredPhoneError = (
  value: string,
  label = 'Phone number'
) => {
  if (normalizePhoneDigits(value) === '') {
    return `${label} is required.`
  }

  if (!isValidPhoneNumber(value)) {
    return 'Enter a valid 10-digit phone number.'
  }

  return ''
}

export const getRequiredZipError = (value: string, label = 'ZIP') => {
  if (normalizeDigits(value) === '') {
    return `${label} is required.`
  }

  if (!isValidZipCode(value)) {
    return 'Enter a valid 5-digit ZIP code.'
  }

  return ''
}

export const getRequiredCardNumberError = (
  value: string,
  label = 'Card number'
) => {
  if (normalizeDigits(value) === '') {
    return `${label} is required.`
  }

  if (!isValidCardNumber(value)) {
    return 'Enter a valid credit card number.'
  }

  return ''
}

export const getRequiredExpirationDateError = (
  value: string,
  label = 'Expiration date'
) => {
  if (normalizeDigits(value) === '') {
    return `${label} is required.`
  }

  if (!isValidExpirationDate(value)) {
    return 'Enter a valid expiration date.'
  }

  return ''
}
